var scrollTimer;
var sideBarWidth = 346;

window.onresize = function (event) {
    if (window.outerWidth < 992) {
        closeNav();
    } else {
        $("#side-bar-menu").css("width", "25%");
        $("#side-bar-menu").css("z-index", "");
        $(".side-menu-overlay").hide();
    }
};

window.onload = function () {
    if ($(".accordion-content-section").length > 0) {
        if (window.location.hash) {
            scrollOnPagination(window.location.hash.slice(1));
            setTimeout(function () {
                scrollOnPagination(window.location.hash.slice(1));
            }, 200);
        } else {
            onScroll();
        }
    }
}

window.onscroll = onScroll;

function onScroll() {
    if (window.outerWidth < 992) {
        var sideNavbar = $(".side-nav-bar-toggler");
        var stickyPosition = sideNavbar.position().top - 100;
        if (window.pageYOffset > stickyPosition) {
            sideNavbar.addClass("sticky")
        } else {
            sideNavbar.removeClass("sticky");
        }
    }

    var removeActiveClass = function (elements) {
        for (var i = 0; i < elements.length; ++i) {
            elements[i].classList.remove('active');
        }
    }
    var anchors = document.querySelectorAll('#side-bar-menu > .verticalMenu > .aside-section > ul.aside-list > li > a[href^="#"]');
    var previousRefElement = null;
    for (var i = 0; i < anchors.length; ++i) {
        var currentRefElement = document.getElementById(anchors[i].getAttribute('href').substring(1));
        var currentRefElementTop = currentRefElement?.getBoundingClientRect().top;
        var topSpace = $("header .navbar").outerHeight() + 140;
        if (currentRefElementTop <= topSpace) {
            previousRefElement = anchors[i];
            if (i == anchors.length - 1) {
                removeActiveClass(anchors);
                anchors[i].classList.add("active");
                scrollAccordionSideMenu(anchors[i]);
                break;
            }
        } else {
            removeActiveClass(anchors);
            if (previousRefElement) {
                previousRefElement.classList.add("active");
            }
            scrollAccordionSideMenu(anchors[i]);
            break;
        }
    }

    if ($("#side-bar-menu > .verticalMenu > .aside-section > ul.aside-list > li > a[href^='#'].active").length < 1) {
        $("#side-bar-menu > .verticalMenu > .aside-section > ul.aside-list > li > a[href^='#']:first").addClass("active");
    }
}

$(document).on("click", "a.aside-link", function (event) {
    if ($(this).attr("href").startsWith("#")) {
        setTimeout(function () {
            scrollOnPagination(window.location.hash.substring(1));
        }, 50);
    }
    if (window.outerWidth < 992) {
        closeNav();
    }

    if ($(this).attr("href").startsWith("#")) {
        window.location.hash = $(this).attr("href");
    }
});

function openNav() {
    var maxZIndex = getMaxZIndex();
    $(".side-menu-overlay").show().css("z-index", maxZIndex + 1);
    $("#side-bar-menu").css("z-index", maxZIndex + 2);
    $("#side-bar-menu").css("width", sideBarWidth);
    $("body").css("overflow", "hidden");
}

function closeNav() {
    $("#side-bar-menu").css("width", "0");;
    $(".side-menu-overlay").hide();
    $("body").css("overflow", "");
}

function isElementVisible($el) {
    var winTop = $(window).scrollTop() + 80;
    var winBottom = winTop + $(window).height();
    var elTop = $el.offset().top;
    var elBottom = elTop + $el.height();
    return ((elBottom <= winBottom) && (elTop >= winTop));
}

function scrollAccordionSideMenu(arg) {
    var scrollElement = document.getElementsByClassName('verticalMenu')[0];
    var elTop = arg.offsetTop - 250;
    var elBottom = $(".verticalMenu").height() + $("#side-bar-menu").offset().top;
    if (elTop < 150) {
        elTop = 0;
    }

    if (elTop > (elBottom - 100)) {
        elTop = elBottom;
    }

    if (!isElementVisible($(arg)) || elTop == elBottom || elTop == 0) {
        scrollElement.scroll({
            top: elTop,
            left: 0,
            behavior: 'smooth'
        })
    }
}